import { Container } from "semantic-ui-react";
import { UpdateVolume } from "Features/Survey";

function EditVolume () {

    return (
        <Container className="page">
            <UpdateVolume />
        </Container>
    );
}

export default EditVolume;